export const venuesData = {
  "rosewood-mayakoba": {
    id: "rosewood-mayakoba",
    name: "Rosewood Mayakoba",
    name_es: "Rosewood Mayakoba",
    description: "Experience the pinnacle of luxury in your own private villa sanctuary, where crystal-clear lagoons meet pristine beaches. Each moment is crafted with meticulous attention to detail, from your private plunge pool to the world-class spa. This exclusive paradise offers an unparalleled setting for your dream wedding, where natural beauty and sophisticated elegance create memories that will last a lifetime.",
    description_es: "Experimenta el pináculo del lujo en tu propio santuario de villa privada, donde lagunas cristalinas se encuentran con playas prístinas. Cada momento está elaborado con una atención meticulosa al detalle, desde tu piscina privada hasta el spa de clase mundial. Este paraíso exclusivo ofrece un escenario sin igual para tu boda soñada, donde la belleza natural y la elegancia sofisticada crean recuerdos que durarán toda la vida.",
    imageUrl: "/images/ctr_rosewood_mayakoba.jpg",
    rating: "5.0/5.0",
    location: "cancun-tulum-riviera-maya",
    type: "Luxury Resort",
    website: "https://www.rosewoodhotels.com/en/mayakoba-riviera-maya?utm_source=google&utm_medium=sem&utm_campaign=rwmyk_pmax&utm_content=evergreen&gad_source=1&gad_campaignid=21824861680&gbraid=0AAAAACg5VVCGAxyMaGkZrKmav9gkoeUrH&gclid=CjwKCAjw3f_BBhAPEiwAaA3K5HR_VSqYI5aVWDIQ_cjen8kJl71hQQ-i9PCIZVRvDLAoDNMq2-kBahoCfnwQAvD_BwE&gclsrc=aw.ds",
    features: {
      primary: ["Beachfront", "Private Villas", "Luxury"],
      amenities: ["Butler Service", "Private Pool", "Spa", "Fine Dining"],
      settings: ["Beach", "Lagoon", "Garden", "Ballroom"]
    },
    capacity: {
      min: 50,
      max: 200
    },
    pricing: {
      base: 20000,
      min: 15000,
      max: 25000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "grand-velas-riviera-maya": {
    id: "grand-velas-riviera-maya",
    name: "Grand Velas Riviera Maya",
    name_es: "Grand Velas Riviera Maya",
    description: "Immerse yourself in a world of unparalleled luxury where every detail is perfected. From the moment you arrive, you'll be enveloped in an atmosphere of sophisticated elegance. Choose from three distinct resort experiences, each offering its own unique charm. The award-winning culinary program, featuring world-class chefs and innovative cuisine, ensures your wedding celebration will be a feast for all senses.",
    description_es: "Sumérgete en un mundo de lujo sin igual donde cada detalle está perfeccionado. Desde el momento en que llegas, estarás envuelto en una atmósfera de elegancia sofisticada. Elige entre tres experiencias distintas de resort, cada una ofreciendo su propio encanto único. El programa culinario galardonado, con chefs de clase mundial y cocina innovadora, asegura que tu celebración de boda será un festín para todos los sentidos.",
    imageUrl: "/images/ctr_grandvelas_venue.jpg",
    rating: "4.9/5.0",
    location: "cancun-tulum-riviera-maya",
    type: "Luxury Resort",
    website: "https://www.velasresorts.com/en/riviera-maya/",
    features: {
      primary: ["Beachfront", "All-inclusive", "Gourmet Dining"],
      amenities: ["Spa", "Multiple Pools", "Kids Club", "Fitness Center"],
      settings: ["Beach", "Jungle", "Garden", "Ballroom"]
    },
    capacity: {
      min: 50,
      max: 300
    },
    pricing: {
      base: 8500,
      min: 5000,
      max: 12000,
      currency: "USD",
      includes: ["Venue", "All-inclusive", "Basic Setup"]
    },
    lists: ["top2025", "bestLuxury", "bestAllInclusive"]
  },
  "le-blanc-cancun": {
    "id": "le-blanc-cancun",
    "name": "Le Blanc Spa Resort Cancún",
    "name_es": "Le Blanc Spa Resort Cancún",
    "description": "An ultra-luxurious, adults-only resort offering sophisticated wedding venues with modern décor, personalized service, and stunning ocean views.",
    "description_es": "Un resort ultra lujoso solo para adultos que ofrece lugares de boda sofisticados con decoración moderna, servicio personalizado y vistas impresionantes al mar.",
    "imageUrl": "https://www.leblancsparesorts.com/images/le-blanc-cancun.jpg",
    "location": "Blvd. Kukulcan, Punta Cancún, Zona Hotelera, Cancún, Quintana Roo, México",
    "rating": "5.0/5.0",
    "venues": [
      {
        "name": "Blanc Gazebo",
        "capacity": 60,
        "type": ["Ceremony"],
        "description": "An elegant beachfront gazebo ideal for intimate ceremonies.",
        "description_es": "Un elegante gazebo frente al mar, ideal para ceremonias íntimas."
      },
      {
        "name": "Blanc Beach",
        "capacity": 150,
        "type": ["Ceremony", "Reception", "Cocktail"],
        "description": "A pristine beach setting perfect for larger ceremonies and receptions.",
        "description_es": "Un entorno de playa prístina, perfecto para ceremonias y recepciones más grandes."
      },
      {
        "name": "Wind Terrace",
        "capacity": 70,
        "type": ["Ceremony", "Reception", "Cocktail"],
        "description": "A terrace with ocean views, suitable for mid-sized events.",
        "description_es": "Una terraza con vistas al mar, adecuada para eventos de tamaño medio."
      },
      {
        "name": "Blanc Sand Ballroom",
        "capacity": 400,
        "type": ["Reception", "Cocktail"],
        "description": "A spacious ballroom with elegant décor for grand receptions.",
        "description_es": "Un amplio salón de baile con decoración elegante para grandes recepciones."
      },
      {
        "name": "Luna Terrace",
        "capacity": 400,
        "type": ["Reception", "Cocktail"],
        "description": "An outdoor terrace offering panoramic views, ideal for large gatherings.",
        "description_es": "Una terraza al aire libre que ofrece vistas panorámicas, ideal para grandes reuniones."
      },
      {
        "name": "Blanc Sol Terrace",
        "capacity": 150,
        "type": ["Reception", "Cocktail"],
        "description": "A semi-private terrace suitable for medium-sized receptions.",
        "description_es": "Una terraza semi-privada adecuada para recepciones de tamaño medio."
      }
    ],
    "features": ["Adults-Only", "All-Inclusive", "Luxury Spa", "Gourmet Dining", "Oceanfront Views"]
  },
  
    "secrets-vine-cancun": {
      "id": "secrets-vine-cancun",
      "name": "Secrets The Vine Cancún",
      "name_es": "Secrets The Vine Cancún",
      "description": "A chic, adults-only resort featuring contemporary design, gourmet dining, and diverse wedding venues overlooking the Caribbean Sea.",
      "description_es": "Un resort elegante solo para adultos con diseño contemporáneo, gastronomía gourmet y diversos lugares para bodas con vistas al mar Caribe.",
      "imageUrl": "https://www.hyattinclusivecollection.com/images/secrets-the-vine-cancun.jpg",
      "location": "Blvd. Kukulcan Km. 14.5, Retorno del Rey, Zona Hotelera, Cancún, Quintana Roo, México",
      "rating": "4.8/5.0",
      "venues": [
        {
          "name": "Beach",
          "capacity": 250,
          "type": ["Ceremony", "Reception"],
          "description": "A picturesque beachfront setting for ceremonies and receptions.",
          "description_es": "Un pintoresco entorno frente al mar para ceremonias y recepciones."
        },
        {
          "name": "The Vine Terrace",
          "capacity": 150,
          "type": ["Ceremony", "Reception"],
          "description": "An elegant terrace with panoramic ocean views, ideal for medium-sized events.",
          "description_es": "Una elegante terraza con vistas panorámicas al mar, ideal para eventos de tamaño medio."
        },
        {
          "name": "Gazebo",
          "capacity": 20,
          "type": ["Ceremony"],
          "description": "An intimate gazebo offering a romantic setting for small ceremonies.",
          "description_es": "Un gazebo íntimo que ofrece un entorno romántico para pequeñas ceremonias."
        },
        {
          "name": "Gazebo Terrace",
          "capacity": 80,
          "type": ["Reception", "Cocktail"],
          "description": "An open-air terrace adjacent to the gazebo, suitable for receptions.",
          "description_es": "Una terraza al aire libre junto al gazebo, adecuada para recepciones."
        },
        {
          "name": "Pool Area",
          "capacity": 180,
          "type": ["Reception"],
          "description": "A stylish poolside venue perfect for lively receptions.",
          "description_es": "Un elegante lugar junto a la piscina, perfecto para recepciones animadas."
        },
        {
          "name": "Ballroom",
          "capacity": 300,
          "type": ["Reception"],
          "description": "A spacious indoor ballroom for grand wedding receptions.",
          "description_es": "Un amplio salón interior para grandes recepciones de boda."
        }
      ],
      "features": ["Adults-Only", "All-Inclusive", "Gourmet Restaurants", "Infinity Pools", "Wine Cellar"]
    
  },
  "la-valise-tulum": {
    id: "la-valise-tulum",
    name: "La Valise Tulum",
    name_es: "La Valise Tulum",
    description: "An intimate, design-driven boutique hotel with just 11 unique suites—six facing the Caribbean and five nestled in the jungle. Enjoy indoor-outdoor showers, hand-crafted details, and Tulum's most exclusive rolling bed suites—sleep under the stars or wake to the sunrise. Perfect for privacy, luxury, and romance.",
    description_es: "Un hotel boutique íntimo y de diseño con solo 11 suites únicas—seis frente al Caribe y cinco en la selva. Disfruta de duchas interiores y exteriores, detalles artesanales y las exclusivas suites con cama rodante para dormir bajo las estrellas o despertar con el amanecer. Perfecto para privacidad, lujo y romance.",
    imageUrl: "https://www.lavalise.com/wp-content/uploads/2020/11/Beachfront-upper-view-La-Valise-Tulum.jpg",
    roomImageUrl: "https://www.lavalise.com/wp-content/uploads/2022/09/La-Valise-Tulum-Hotel-Mexico-16.jpg",
    location: "Carretera Tulum-Boca Paila Km 8.7, Zona Hotelera, Tulum, Quintana Roo",
    rating: "5.0/5.0",
    features: [
      "Beachfront & Jungle Suites",
      "Exclusive Rolling Bed Suites",
      "Indoor-Outdoor Showers",
      "Personalized Service",
      "Adults-Oriented Privacy"
    ]
  },
  
    "azulik-tulum": {
      id: "azulik-tulum",
      name: "Azulik Tulum",
      name_es: "Azulik Tulum",
      description: "A globally renowned eco-luxury retreat in Tulum, famed for its jaw-dropping treehouse villas, spiritual ambiance, and immersive art and dining experiences. Azulik is the ultimate venue for couples seeking a magical, unconventional, and design-forward event surrounded by nature.",
      description_es: "Un retiro eco-lujo de fama mundial en Tulum, famoso por sus villas en los árboles, ambiente espiritual y experiencias inmersivas de arte y gastronomía. Azulik es el lugar ideal para parejas que buscan un evento mágico, poco convencional y con diseño, rodeados de naturaleza.",
      imageUrl: "/images/ctr_azulik.jpg",
      location: "Carretera Tulum-Punta Allen Km 5, Zona Hotelera, Tulum, Quintana Roo",
      rating: "4.8/5.0",
      type: "Luxury Resort",
      features: [
        "Treehouse Villas",
        "Private Beach",
        "Iconic Nest Restaurant (Kin Toh)",
        "Immersive Art Gallery (SFER IK)",
        "Holistic Spa & Wellness"
      ],
      venues: [
        {
          name: "Kin Toh",
          capacity: 120,
          type: ["Reception", "Cocktail", "Dinner"],
          description: "Nest-inspired restaurant above the jungle canopy, ideal for magical sunset dinners and stylish receptions.",
          description_es: "Restaurante en forma de nido sobre la selva, ideal para cenas mágicas al atardecer y recepciones elegantes."
        },
        {
          name: "Azulik Private Beach",
          capacity: 100,
          type: ["Ceremony", "Reception"],
          description: "A pristine, intimate stretch of sand—perfect for barefoot ceremonies and private sunset events.",
          description_es: "Una playa virgen e íntima, perfecta para ceremonias barefoot y eventos privados al atardecer."
        },
        {
          name: "SFER IK Gallery",
          capacity: 80,
          type: ["Cocktail", "Private Event"],
          description: "Organic, immersive art space for creative gatherings, afterparties, or unique wedding moments.",
          description_es: "Espacio de arte orgánico e inmersivo para eventos creativos, afterparties o momentos únicos de boda."
        }
      ]
    
  },
  
  

  
  "esperanza-auberge": {
    id: "esperanza-auberge",
    name: "Esperanza, Auberge Resorts Collection",
    name_es: "Esperanza, Auberge Resorts Collection",
    description: "Perched dramatically on the cliffs of Los Cabos, Esperanza offers a breathtaking backdrop for your special day. The resort's intimate setting and legendary service create an atmosphere of exclusive sophistication.",
    description_es: "Ubicado dramáticamente en los acantilados de Los Cabos, Esperanza ofrece un impresionante telón de fondo para tu día especial. El ambiente íntimo del resort y su servicio legendario crean una atmósfera de sofisticación exclusiva.",
    website: "https://www.aubergeresorts.com/esperanza",
    imageUrl: "https://dreffui1gbt6t.cloudfront.net/images/esp/esp-weddings-card-larger-upsize-768x512.jpg",
    rating: "5.0/5.0",
    location: "los-cabos",
    type: "Luxury Resort",
    features: {
      primary: ["Cliffside", "Ocean View", "Luxury"],
      amenities: ["Spa", "Private Beach", "Fine Dining", "Butler Service"],
      settings: ["Cliff", "Beach", "Garden", "Restaurant"]
    },
    capacity: {
      min: 30,
      max: 150
    },
    pricing: {
      base: 18000,
      min: 12000,
      max: 25000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "general-prim-mexico-city": {
    id: "general-prim-mexico-city",
    name: "General Prim",
    name_es: "General Prim",
    description: "Experience timeless elegance in this stunning 19th-century mansion, where classic architecture meets modern luxury. Versatile patios and elegant halls set the stage for a sophisticated celebration, with the Juárez neighborhood adding an urban, chic backdrop.",
    description_es: "Vive la elegancia atemporal en esta mansión del siglo XIX, donde la arquitectura clásica se une al lujo moderno. Sus patios y salones versátiles crean el escenario ideal, con el barrio Juárez como fondo urbano y chic.",
    website: "https://mexicocity.cdmx.gob.mx/venues/proyecto-publico-prim/?lang=es",
    imageUrl: "/images/generalprim2.jpg",
    location: "mexico-city",
    rating: "4.8/5",
    features: {
      primary: ["Ballroom"],
      amenities: [],
      settings: ["Ballroom", "Rooftop", "Garden", "Restaurant"]
    },
    capacity: {
      min: 50,
      max: 450
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  "parque-quetzalcoatl-mexico-city": {
    id: "parque-quetzalcoatl-mexico-city",
    name: "Parque Quetzalcóatl",
    name_es: "Parque Quetzalcóatl",
    description: "A breathtaking, surreal park on the outskirts of Mexico City, known for its organic architecture, lush landscapes, and magical ambiance—perfect for couples seeking a truly one-of-a-kind wedding setting.",
    description_es: "Un parque surrealista a las afueras de la Ciudad de México, famoso por su arquitectura orgánica, paisajes exuberantes y ambiente mágico; ideal para parejas que buscan un escenario de boda verdaderamente único.",
    website: "https://www.parquequetzalcoatl.com/",
    imageUrl: "/images/quetzalcoatl.jpg",
    location: "mexico-city",
    rating: "4.9/5",
    features: {
      primary: ["Garden"],
      amenities: [],
      settings: ["Garden", "Outdoor", "Park"]
    },
    capacity: {
      min: 80,
      max: 250
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "On-Site Coordination"],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  "ex-convento-san-hipolito-mexico-city": {
    id: "ex-convento-san-hipolito-mexico-city",
    name: "Ex Convento de San Hipólito",
    name_es: "Ex Convento de San Hipólito",
    description: "A majestic former convent with grand stone halls, soaring ceilings, and historic charm—ideal for sophisticated weddings with a sense of tradition and drama.",
    description_es: "Un majestuoso ex convento con grandes salones de piedra, techos altos y encanto histórico, ideal para bodas sofisticadas con un toque de tradición y dramatismo.",
    imageUrl: "https://images.inmexico.com/2016/08/Captura-de-pantalla-2016-08-03-a-las-6.16.37-p.m.-copia.jpg",
    location: "mexico-city",
    rating: "4.9/5",
    features: {
      primary: ["Historic Venue"],
      amenities: [],
      settings: ["Ballroom", "Historic", "Indoor"]
    },
    capacity: {
      min: 20,
      max: 700
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: ["Venue", "Coordination", "Basic Setup"],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  "colegio-vizcainas-mexico-city": {
    id: "colegio-vizcainas-mexico-city",
    name: "Colegio de las Vizcaínas",
    name_es: "Colegio de las Vizcaínas",
    description: "An architectural jewel in the heart of Mexico City, Vizcaínas features elegant baroque courtyards and grand salons. Its timeless beauty and rich history create an exceptional backdrop for weddings and high-profile events.",
    description_es: "Una joya arquitectónica en el corazón de la Ciudad de México, Vizcaínas destaca por sus elegantes patios barrocos y salones majestuosos. Su belleza atemporal y rica historia ofrecen un entorno excepcional para bodas y eventos de alto nivel.",
    imageUrl: "https://eventos.vizcainas.mx/wp-content/uploads/2022/08/vizcainas-galeria-6-1.jpg",
    location: "mexico-city",
    rating: "4.9/5",
    features: {
      primary: ["Historic Venue"],
      amenities: [],
      settings: ["Courtyard", "Historic", "Ballroom"]
    },
    capacity: {
      min: 100,
      max: 1000
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: ["Venue", "Coordination", "Basic Setup"],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  "jardin-huayacan-mexico-city": {
    id: "jardin-huayacan-mexico-city",
    name: "Jardín Huayacán",
    name_es: "Jardín Huayacán",
    description: "A lush, private garden venue on the city's south side, known for its peaceful ambiance, elegant landscaping, and flexible indoor-outdoor spaces—perfect for intimate or grand weddings surrounded by nature.",
    description_es: "Un jardín privado y exuberante al sur de la ciudad, reconocido por su ambiente tranquilo, paisajismo elegante y espacios versátiles; ideal para bodas íntimas o grandes rodeadas de naturaleza.",
    imageUrl: "https://images.squarespace-cdn.com/content/v1/592d841517bffc6464b20137/1628014398722-I64HGAGJBOZF0TEE6W9O/120462428_3150207641773005_5215140214643527973_n.jpeg?format=2500w",
    location: "Tlalpan, Mexico City",
    rating: "4.8/5",
    features: {
      primary: ["Garden"],
      amenities: [],
      settings: ["Garden", "Outdoor", "Tent"]
    },
    capacity: {
      min: 80,
      max: 350
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  "jardin-rancho-la-pena-mexico-city": {
    id: "jardin-rancho-la-pena-mexico-city",
    name: "Jardín Rancho La Peña",
    name_es: "Jardín Rancho La Peña",
    description: "Jardín Rancho La Peña, located just 15 minutes from Santa Fe, is a beautiful venue surrounded by nature, offering versatile gardens and a greenhouse for events of all sizes. With its peaceful setting and personalized service, it's an ideal spot for unforgettable weddings and celebrations.",
    description_es: "Jardín Rancho La Peña, a solo 15 minutos de Santa Fe, es un hermoso lugar rodeado de naturaleza que ofrece jardines versátiles y un invernadero para eventos de cualquier tamaño. Su ambiente tranquilo y servicio personalizado lo hacen ideal para bodas y celebraciones inolvidables.",
    imageUrl: "/images/mexico_jarding_rlp.jpg",
    location: "mexico-city",
    rating: "4.8/5",
    features: {
      primary: ["Garden"],
      amenities: [],
      settings: ["Garden", "Outdoor", "Terrace"]
    },
    capacity: {
      min: 80,
      max: 500
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: ["Venue", "Setup", "Coordination"],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  "rosewood-san-miguel": {
    id: "rosewood-san-miguel",
    name: "Rosewood San Miguel de Allende",
    name_es: "Rosewood San Miguel de Allende",
    description: "Enjoy refined elegance in the heart of Mexico's most charming colonial city. With lush gardens, city views, and a blend of historic architecture and modern luxury, this venue offers a magical setting and world-class service for an unforgettable celebration.",
    description_es: "Disfruta de elegancia en el corazón de la ciudad colonial más encantadora de México. Con jardines exuberantes, vistas a la ciudad y una mezcla de arquitectura histórica y lujo moderno, este lugar ofrece un escenario mágico y servicio de primer nivel para una celebración inolvidable.",
    imageUrl: "/images/sanmiguel_rosewood.jpg",
    rating: "4.9/5.0",
    location: "san-miguel-de-allende",
    type: "Luxury Hotel",
    website: "https://www.rosewoodhotels.com/en/san-miguel-de-allende",
    features: {
      primary: ["Colonial", "Garden", "City View"],
      amenities: ["Spa", "Rooftop Pool", "Fine Dining", "Butler Service"],
      settings: ["Garden", "Rooftop", "Ballroom", "Courtyard"]
    },
    capacity: {
      min: 30,
      max: 150
    },
    pricing: {
      base: 14000,
      min: 10000,
      max: 18000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestColonial"]
  },
  "one-only-palmilla": {
    id: "one-only-palmilla",
    name: "One&Only Palmilla",
    name_es: "One&Only Palmilla",
    description: "Experience the epitome of luxury in this legendary resort, where pristine beaches meet the dramatic Baja landscape. The resort's exclusive atmosphere and impeccable service create an unforgettable setting for your celebration.",
    description_es: "Experimenta el epítome del lujo en este resort legendario, donde playas prístinas se encuentran con el dramático paisaje de Baja. La atmósfera exclusiva del resort y su servicio impecable crean un escenario inolvidable para tu celebración.",
    imageUrl: "https://assets.kerzner.com/api/public/content/a0effdbce0e8432cbca074f1ed35d3b5?v=d7d73cac&t=w1200",
    rating: "5.0/5.0",
    location: "los-cabos",
    type: "Luxury Resort",
    website: "https://www.oneandonlyresorts.com/palmilla",
    features: {
      primary: ["Beachfront", "Luxury", "Exclusive"],
      amenities: ["Spa", "Private Beach", "Fine Dining", "Butler Service"],
      settings: ["Beach", "Garden", "Ballroom", "Restaurant"]
    },
    capacity: {
      min: 30,
      max: 200
    },
    pricing: {
      base: 22000,
      min: 15000,
      max: 30000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "quinta-real-oaxaca": {
    id: "quinta-real-oaxaca",
    name: "Quinta Real Oaxaca",
    name_es: "Quinta Real Oaxaca",
    description: "Restored 16th-century convent, dramatic courtyards, authentic and magical colonial charm.",
    description_es: "Convento restaurado del siglo XVI, patios dramáticos, auténtico y mágico encanto colonial.",
    imageUrl: "https://www.quintareal.com/images/QR-OAX_002_Facade_01.jpg",
    rating: "4.8/5.0",
    location: "oaxaca",
    type: "Historic Hotel",
    website: "https://www.quintareal.com/en/oaxaca",
    features: ["Historic", "Colonial", "Courtyard"],
    lists: ["top2025", "bestHistoric"],
    pricing: {
      base: 9000,
      min: 6000,
      max: 12000
    }
  },
  "nizuc-resort": {
    id: "nizuc-resort",
    name: "Nizuc Resort & Spa",
    name_es: "Nizuc Resort & Spa",
    description: "Discover a secluded paradise where modern luxury meets natural beauty. This ultra-chic beachfront resort offers an exclusive setting for your celebration, with its contemporary design and impeccable service. The pristine beaches and lush tropical surroundings create a magical atmosphere, while the resort's sophisticated amenities ensure your wedding day is nothing short of extraordinary.",
    description_es: "Descubre un paraíso aislado donde el lujo moderno se encuentra con la belleza natural. Este resort ultra-chic frente al mar ofrece un escenario exclusivo para tu celebración, con su diseño contemporáneo y servicio impecable. Las playas prístinas y los exuberantes alrededores tropicales crean una atmósfera mágica, mientras que las sofisticadas comodidades del resort aseguran que tu día de boda sea nada menos que extraordinario.",
    imageUrl: "https://www.nizuc.com/wp-content/uploads/2020/09/Amores-Canteiro-2019-160-1280x853.jpg",
    rating: "4.8/5.0",
    location: "cancun-tulum-riviera-maya",
    type: "Luxury Resort",
    website: "https://www.nizuc.com",
    features: {
      primary: ["Beachfront", "Modern", "Luxury"],
      amenities: ["Spa", "Private Beach", "Fine Dining", "Pool"],
      settings: ["Beach", "Garden", "Restaurant", "Pool"]
    },
    capacity: {
      min: 50,
      max: 200
    },
    pricing: {
      base: 16000,
      min: 12000,
      max: 20000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "acre-resort": {
    id: "acre-resort",
    name: "Acre Resort",
    name_es: "Acre Resort",
    description: "Immerse yourself in a magical oasis where rustic charm meets sophisticated luxury. This unique venue, nestled in a lush palm grove, offers an enchanting setting for your celebration. The bohemian-chic atmosphere, combined with farm-to-table dining and treehouse accommodations, creates an unforgettable experience. This is where nature's beauty and modern comfort come together to create your perfect wedding day.",
    description_es: "Sumérgete en un oasis mágico donde el encanto rústico se encuentra con el lujo sofisticado. Este lugar único, enclavado en un exuberante palmar, ofrece un escenario encantador para tu celebración. La atmósfera bohemia-chic, combinada con la gastronomía de la granja a la mesa y alojamientos en casas en los árboles, crea una experiencia inolvidable. Aquí es donde la belleza de la naturaleza y la comodidad moderna se unen para crear tu día de boda perfecto.",
    imageUrl: "https://acreresort.com/wp-content/uploads/2025/02/acre-resort-weddings-26.jpg",
    rating: "4.8/5.0",
    location: "los-cabos",
    type: "Boutique Resort",
    website: "https://www.acreresort.com",
    features: {
      primary: ["Nature", "Rustic", "Boutique"],
      amenities: ["Farm-to-Table", "Pool", "Bar", "Treehouses"],
      settings: ["Palm Grove", "Garden", "Restaurant", "Pool"]
    },
    capacity: {
      min: 30,
      max: 100
    },
    pricing: {
      base: 12000,
      min: 8000,
      max: 16000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestBoutique"]
  },

    "chable-maroma": {
      id: "chable-maroma",
      name: "Chablé Maroma",
      name_es: "Chablé Maroma",
      description: "An ultra-luxury, boutique resort with only 70 private villas, each with its own pool. Renowned for privacy, personalized service, and an award-winning spa on one of the Riviera Maya's finest beaches.",
      description_es: "Un resort boutique de ultra lujo con solo 70 villas privadas, cada una con su propia alberca. Reconocido por su privacidad, servicio personalizado y un spa galardonado en una de las mejores playas de la Riviera Maya.",
      imageUrl: "/images/ctr_chablemaroma.jpg",
      location: "Carretera Federal Chetumal-Puerto Juarez Km 298, Punta Maroma, Playa del Carmen, Quintana Roo",
      rating: "5.0/5.0",
      type: "Luxury Resort",
      scores: {
        privacy: 5.0,
        service: 5.0,
        food: 4.9,
        setting: 5.0,
        overall: 5.0
      },
      features: [
        "Private Pool Villas",
        "Award-Winning Spa",
        "Beachfront Ceremonies",
        "Yucatán-Inspired Fine Dining",
        "Full Resort Buyout Available"
      ],
      venues: [
        {
          name: "Beachfront",
          capacity: 100,
          type: ["Ceremony", "Reception"],
          description: "Pristine white sand beach with turquoise Caribbean waters; perfect for exclusive ceremonies and receptions.",
          description_es: "Playa de arena blanca y aguas turquesas; perfecta para ceremonias y recepciones exclusivas."
        },
        {
          name: "La Ceiba Garden",
          capacity: 80,
          type: ["Ceremony", "Reception"],
          description: "A magical garden space surrounded by tropical flora, ideal for intimate gatherings.",
          description_es: "Un jardín mágico rodeado de flora tropical, ideal para reuniones íntimas."
        },
        {
          name: "Private Villas",
          capacity: 20,
          type: ["Intimate Events"],
          description: "Ultra-private villa spaces for micro weddings and special events.",
          description_es: "Espacios ultra privados para bodas pequeñas y eventos especiales."
        }
      ]
    },
    "hotel-esencia": {
      id: "hotel-esencia",
      name: "Hotel Esencia",
      name_es: "Hotel Esencia",
      description: "Once a private estate, Hotel Esencia is now the Riviera Maya's most exclusive small luxury hotel, set on a pristine beach with only 45 rooms on 50 private acres. Famed for its discreet, barefoot-chic elegance and world-class personalized service.",
      description_es: "Anteriormente una finca privada, Hotel Esencia es ahora el hotel boutique más exclusivo de la Riviera Maya, ubicado en una playa prístina con solo 45 habitaciones en 20 hectáreas privadas. Famoso por su elegancia discreta y servicio personalizado de clase mundial.",
      imageUrl: "/images/ctr_hotelescencia.jpg",
      location: "Carretera Tulum-Cancún Km 265, Xpu-Ha, Quintana Roo",
      rating: "5.0/5.0",
      scores: {
        privacy: 5.0,
        service: 5.0,
        food: 4.9,
        setting: 5.0,
        overall: 5.0
      },
      features: [
        "Exclusive Beachfront",
        "Esencia Mansion (Private Villa)",
        "Award-Winning Spa",
        "World-Class Dining",
        "Personalized, Discreet Service"
      ],
      venues: [
        {
          name: "Beachfront",
          capacity: 80,
          type: ["Ceremony", "Reception"],
          description: "A private, pristine beach for intimate and exclusive ceremonies or receptions.",
          description_es: "Playa prístina y privada para ceremonias o recepciones íntimas y exclusivas."
        },
        {
          name: "Esencia Mansion",
          capacity: 50,
          type: ["Ceremony", "Reception", "Private Party"],
          description: "A 12,000-square-foot private mansion surrounded by gardens—ideal for the most exclusive events.",
          description_es: "Mansión privada de 1,100 m² rodeada de jardines, ideal para los eventos más exclusivos."
        },
        {
          name: "Garden & Pool Area",
          capacity: 100,
          type: ["Reception", "Cocktail"],
          description: "Lush gardens and a sophisticated pool setting for elegant outdoor receptions.",
          description_es: "Jardines exuberantes y una alberca sofisticada para recepciones elegantes al aire libre."
        }
      ]
    },  
  "four-seasons-pv": {
    id: "four-seasons-pv",
    name: "Four Seasons Resort Punta Mita",
    name_es: "Four Seasons Resort Punta Mita",
    description: "Escape to a paradise where luxury meets natural beauty in perfect harmony. This exclusive beachfront resort offers a private beach club, world-class spa, and exceptional service that will make your wedding celebration truly extraordinary. The stunning Pacific Ocean views and lush tropical surroundings create a magical backdrop for your special day, while the resort's sophisticated amenities ensure every detail is perfect.",
    description_es: "Escapa a un paraíso donde el lujo se encuentra con la belleza natural en perfecta armonía. Este exclusivo resort frente al mar ofrece un club de playa privado, spa de clase mundial y servicio excepcional que hará que tu celebración de boda sea verdaderamente extraordinaria. Las impresionantes vistas al Océano Pacífico y los exuberantes alrededores tropicales crean un telón de fondo mágico para tu día especial, mientras que las sofisticadas comodidades del resort aseguran que cada detalle sea perfecto.",
    imageUrl: "https://www.fourseasons.com/alt/img-opt/~80.1220.0,0000-492,3791-3000,0000-1687,5000/publish/content/dam/fourseasons/images/web/PUN/PUN_2098_original.jpg",
    rating: "5.0/5.0",
    location: "puerto-vallarta",
    type: "Luxury Resort",
    website: "https://www.fourseasons.com/punta-mita",
    features: {
      primary: ["Beachfront", "Private Beach", "Luxury"],
      amenities: ["Spa", "Private Beach Club", "Fine Dining", "Butler Service"],
      settings: ["Beach", "Garden", "Restaurant", "Pool"]
    },
    capacity: {
      min: 30,
      max: 150
    },
    pricing: {
      base: 28000,
      min: 20000,
      max: 40000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury", "bestBeachfront"]
  },
  "banyan-tree-mayakoba": {
    id: "banyan-tree-mayakoba",
    name: "Banyan Tree Mayakoba",
    name_es: "Banyan Tree Mayakoba",
    description: "Experience the ultimate in privacy and luxury in your own pool villa sanctuary. This exclusive resort offers a perfect blend of natural beauty and sophisticated comfort. The award-winning spa and pristine beaches create an idyllic setting for your celebration, while the resort's exceptional service ensures every detail is perfect. This is where your dream wedding becomes a reality in the most spectacular way.",
    description_es: "Experimenta lo último en privacidad y lujo en tu propio santuario de villa con piscina. Este exclusivo resort ofrece una perfecta combinación de belleza natural y comodidad sofisticada. El spa galardonado y las playas prístinas crean un escenario idílico para tu celebración, mientras que el servicio excepcional del resort asegura que cada detalle sea perfecto. Aquí es donde tu boda soñada se convierte en realidad de la manera más espectacular.",
    imageUrl: "/images/ctr_banyan.jpg",
    rating: "5.0/5.0",
    location: "cancun-tulum-riviera-maya",
    type: "Luxury Resort",
    website: "https://www.banyantree.com/mexico/mayakoba",
    features: {
      primary: ["Beachfront", "Private Pool", "Luxury"],
      amenities: ["Spa", "Private Beach", "Fine Dining", "Butler Service"],
      settings: ["Beach", "Garden", "Villa", "Restaurant"]
    },
    capacity: {
      min: 30,
      max: 150
    },
    pricing: {
      base: 22000,
      min: 15000,
      max: 30000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "hacienda-la-escoba": {
    id: "hacienda-la-escoba",
    name: "Hacienda La Escoba",
    name_es: "Hacienda La Escoba",
    description: "A grand and historic hacienda offering beautiful colonial architecture and expansive grounds for large, elegant weddings.",
    description_es: "Una hacienda histórica y grandiosa que ofrece hermosa arquitectura colonial y amplios terrenos para bodas elegantes.",
    imageUrl: "", // TODO: Add image
    rating: "4.8/5.0",
    location: "guadalajara",
    type: "Historic Hacienda",
    website: "https://www.haciendalaescoba.com",
    features: {
      primary: ["Historic", "Colonial", "Garden"],
      amenities: ["Garden", "Courtyard", "Ballroom"],
      settings: ["Garden", "Courtyard", "Ballroom"]
    },
    capacity: {
      min: 100,
      max: 300
    },
    pricing: {
      base: 12000,
      min: 8000,
      max: 16000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestHistoric"]
  },
  "hacienda-la-magdalena": {
    id: "hacienda-la-magdalena",
    name: "Hacienda La Magdalena",
    name_es: "Hacienda La Magdalena",
    description: "A beautifully restored 19th-century estate with expansive gardens and elegant interiors in Zapopan, perfect for luxury weddings.",
    description_es: "Una finca del siglo XIX bellamente restaurada con jardines expansivos e interiores elegantes en Zapopan, perfecta para bodas de lujo.",
    imageUrl: "", // TODO: Add image
    rating: "4.9/5.0",
    location: "guadalajara",
    type: "Historic Estate",
    website: "https://www.haciendalaescoba.com",
    features: {
      primary: ["Historic", "Garden", "Luxury"],
      amenities: ["Garden", "Ballroom", "Courtyard"],
      settings: ["Garden", "Ballroom", "Courtyard"]
    },
    capacity: {
      min: 50,
      max: 200
    },
    pricing: {
      base: 15000,
      min: 10000,
      max: 20000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestHistoric"]
  },
  "casa-pedro-loza": {
    id: "casa-pedro-loza",
    name: "Casa Pedro Loza",
    name_es: "Casa Pedro Loza",
    description: "Boutique colonial hotel with rooftop city views, ideal for intimate urban weddings in the heart of Guadalajara.",
    description_es: "Hotel colonial boutique con vistas a la ciudad desde la azotea, ideal para bodas urbanas íntimas en el corazón de Guadalajara.",
    imageUrl: "", // TODO: Add image
    rating: "4.7/5.0",
    location: "guadalajara",
    type: "Boutique Hotel",
    website: "https://www.casapedroloza.com",
    features: {
      primary: ["Colonial", "Rooftop", "Boutique"],
      amenities: ["Rooftop", "Restaurant", "Bar"],
      settings: ["Rooftop", "Garden", "Restaurant"]
    },
    capacity: {
      min: 30,
      max: 100
    },
    pricing: {
      base: 8000,
      min: 5000,
      max: 12000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestBoutique"]
  },
  "hyatt-regency-andares": {
    id: "hyatt-regency-andares",
    name: "Hyatt Regency Andares Guadalajara",
    name_es: "Hyatt Regency Andares Guadalajara",
    description: "Modern luxury hotel with sophisticated ballrooms and event spaces, ideal for elegant urban celebrations.",
    description_es: "Hotel de lujo moderno con salones y espacios para eventos sofisticados, ideal para celebraciones urbanas elegantes.",
    imageUrl: "", // TODO: Add image
    rating: "4.7/5.0",
    location: "guadalajara",
    type: "Luxury Hotel",
    website: "https://www.hyatt.com/en-US/hotel/mexico/hyatt-regency-andares-guadalajara/guad",
    features: {
      primary: ["Modern", "Luxury", "Ballroom"],
      amenities: ["Ballroom", "Restaurant", "Spa"],
      settings: ["Ballroom", "Garden", "Restaurant"]
    },
    capacity: {
      min: 50,
      max: 300
    },
    pricing: {
      base: 10000,
      min: 7000,
      max: 15000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestUrban"]
  },
  "mansion-magnolia": {
    id: "mansion-magnolia",
    name: "Mansión Magnolia",
    name_es: "Mansión Magnolia",
    description: "A romantic neoclassical mansion from 1890 with lush gardens and refined indoor spaces, perfect for an elegant wedding.",
    description_es: "Una mansión neoclásica romántica de 1890 con jardines exuberantes y espacios interiores refinados, perfecta para una boda elegante.",
    imageUrl: "", // TODO: Add image
    rating: "4.8/5.0",
    location: "guadalajara",
    type: "Historic Mansion",
    website: "https://www.haciendalaescoba.com",
    features: {
      primary: ["Historic", "Garden", "Elegant"],
      amenities: ["Garden", "Ballroom", "Courtyard"],
      settings: ["Garden", "Ballroom", "Courtyard"]
    },
    capacity: {
      min: 50,
      max: 150
    },
    pricing: {
      base: 12000,
      min: 8000,
      max: 16000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestHistoric"]
  },
  "casa-cuca": {
    id: "casa-cuca",
    name: "Casa Cuca",
    name_es: "Casa Cuca",
    description: "Nature-rich venue near Bosque de la Primavera offering expansive views, open gardens, and relaxed sophistication.",
    description_es: "Lugar rico en naturaleza cerca del Bosque de la Primavera que ofrece vistas expansivas, jardines abiertos y sofisticación relajada.",
    imageUrl: "", // TODO: Add image
    rating: "4.8/5.0",
    location: "guadalajara",
    type: "Nature Venue",
    website: "https://www.haciendalaescoba.com",
    features: {
      primary: ["Nature", "Garden", "Scenic"],
      amenities: ["Garden", "Outdoor Kitchen", "Terraces"],
      settings: ["Garden", "Terrace", "Outdoor"]
    },
    capacity: {
      min: 30,
      max: 100
    },
    pricing: {
      base: 9000,
      min: 6000,
      max: 12000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestNature"]
  },
  "hotel-riu-plaza": {
    id: "hotel-riu-plaza",
    name: "Hotel Riu Plaza Guadalajara",
    name_es: "Hotel Riu Plaza Guadalajara",
    description: "Modern and versatile event spaces, known for its towering presence and excellent service for large-scale urban weddings.",
    description_es: "Espacios para eventos modernos y versátiles, conocidos por su presencia imponente y excelente servicio para bodas urbanas a gran escala.",
    imageUrl: "", // TODO: Add image
    rating: "4.7/5.0",
    location: "guadalajara",
    type: "Luxury Hotel",
    website: "https://www.riu.com/hoteles/hotel-riu-plaza-guadalajara",
    features: {
      primary: ["Modern", "Urban", "Versatile"],
      amenities: ["Ballroom", "Restaurant", "Spa"],
      settings: ["Ballroom", "Garden", "Restaurant"]
    },
    capacity: {
      min: 100,
      max: 500
    },
    pricing: {
      base: 12000,
      min: 8000,
      max: 20000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestUrban"]
  },
  "casa-fayette": {
    id: "casa-fayette",
    name: "Casa Fayette",
    name_es: "Casa Fayette",
    description: "A stylish boutique hotel with a beautiful rooftop pool and terrace, offering a chic and contemporary setting for intimate to medium-sized events.",
    description_es: "Un hotel boutique elegante con una hermosa piscina y terraza en la azotea, que ofrece un ambiente chic y contemporáneo para eventos íntimos y medianos.",
    imageUrl: "", // TODO: Add image
    rating: "4.8/5.0",
    location: "guadalajara",
    type: "Boutique Hotel",
    website: "https://www.casapedroloza.com",
    features: {
      primary: ["Boutique", "Rooftop", "Modern"],
      amenities: ["Rooftop Pool", "Restaurant", "Bar"],
      settings: ["Rooftop", "Restaurant", "Garden"]
    },
    capacity: {
      min: 30,
      max: 100
    },
    pricing: {
      base: 9000,
      min: 6000,
      max: 12000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestBoutique"]
  },
  "salon-candiles": {
    id: "salon-candiles",
    name: "Salón Candiles (Centro de Convenciones Expo Guadalajara)",
    name_es: "Salón Candiles (Centro de Convenciones Expo Guadalajara)",
    description: "While a convention center, its main hall can be transformed into a grand setting for very large weddings.",
    description_es: "Aunque es un centro de convenciones, su salón principal puede transformarse en un gran escenario para bodas muy grandes.",
    imageUrl: "", // TODO: Add image
    rating: "4.6/5.0",
    location: "guadalajara",
    type: "Convention Center",
    website: "https://www.expo-guadalajara.com",
    features: {
      primary: ["Large", "Versatile", "Modern"],
      amenities: ["Ballroom", "Kitchen", "Parking"],
      settings: ["Ballroom", "Garden", "Outdoor"]
    },
    capacity: {
      min: 200,
      max: 1000
    },
    pricing: {
      base: 15000,
      min: 10000,
      max: 25000,
      currency: "USD",
      includes: ["Venue", "Basic Setup"]
    },
    lists: ["bestLarge"]
  },
  "barranca-huentitan": {
    id: "barranca-huentitan",
    name: "Barranca de Huentitán",
    name_es: "Barranca de Huentitán",
    description: "For adventurous couples, some spots near the barranca offer unique, breathtaking natural backdrops, though may require more external planning. (Less traditional, more unique).",
    description_es: "Para parejas aventureras, algunos lugares cerca de la barranca ofrecen fondos naturales únicos e impresionantes, aunque pueden requerir más planificación externa. (Menos tradicional, más único).",
    imageUrl: "", // TODO: Add image
    rating: "4.5/5.0",
    location: "guadalajara",
    type: "Natural Venue",
    website: "https://www.haciendalaescoba.com",
    features: {
      primary: ["Natural", "Scenic", "Unique"],
      amenities: ["Outdoor", "Scenic Views"],
      settings: ["Outdoor", "Natural"]
    },
    capacity: {
      min: 20,
      max: 100
    },
    pricing: {
      base: 5000,
      min: 3000,
      max: 8000,
      currency: "USD",
      includes: ["Venue"]
    },
    lists: ["bestUnique"]
  },
  "waldorf-astoria-pedregal": {
    id: "waldorf-astoria-pedregal",
    name: "Waldorf Astoria Los Cabos Pedregal",
    name_es: "Waldorf Astoria Los Cabos Pedregal",
    description: "A secluded paradise carved into a cliff, offering stunning ocean views from private plunge pools, direct beach access, and unparalleled privacy. Perfect for intimate celebrations with a touch of luxury.",
    description_es: "Un paraíso aislado tallado en un acantilado, que ofrece impresionantes vistas al océano desde piscinas privadas, acceso directo a la playa y privacidad sin igual. Perfecto para celebraciones íntimas con un toque de lujo.",
    imageUrl: "https://cdn.waldorfastorialoscabospedregal.com/wp-content/uploads/2021/11/14173144/Erika_Erik-Wedding-jasminleephotography-Nov-2021-62-1.jpg",
    rating: "5.0/5.0",
    location: "los-cabos",
    type: "Luxury Resort",
    website: "https://www.waldorfastorialoscabospedregal.com",
    features: {
      primary: ["Cliffside", "Private Beach", "Luxury"],
      amenities: ["Spa", "Private Pool", "Fine Dining", "Butler Service"],
      settings: ["Cliff", "Beach", "Garden", "Restaurant"]
    },
    capacity: {
      min: 30,
      max: 150
    },
    pricing: {
      base: 20000,
      min: 15000,
      max: 25000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "the-cape-thompson": {
    id: "the-cape-thompson",
    name: "The Cape, a Thompson Hotel",
    name_es: "The Cape, un Hotel Thompson",
    description: "A modern architectural masterpiece offering panoramic ocean views and a sophisticated atmosphere. The resort's contemporary design and exceptional service create a unique setting for your celebration.",
    description_es: "Una obra maestra arquitectónica moderna que ofrece vistas panorámicas al océano y una atmósfera sofisticada. El diseño contemporáneo del resort y su servicio excepcional crean un escenario único para tu celebración.",
    imageUrl: "https://assets.hyatt.com/content/dam/hyatt/hyattdam/images/2022/04/07/1156/CSLTH-P0194-Wedding-Venue-Upper-Pool-Terrace.jpg/CSLTH-P0194-Wedding-Venue-Upper-Pool-Terrace.4x3.jpg",
    rating: "4.7/5.0",
    location: "los-cabos",
    type: "Luxury Hotel",
    website: "https://www.thompsonhotels.com/the-cape-los-cabos",
    features: {
      primary: ["Modern", "Ocean View", "Luxury"],
      amenities: ["Rooftop Pool", "Spa", "Fine Dining", "Beach Access"],
      settings: ["Rooftop", "Beach", "Restaurant", "Garden"]
    },
    capacity: {
      min: 30,
      max: 120
    },
    pricing: {
      base: 16000,
      min: 12000,
      max: 20000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestModern"]
  },
  "flora-farms": {
    id: "flora-farms",
    name: "Flora Farms",
    name_es: "Flora Farms",
    description: "A unique organic farm setting offering a rustic yet sophisticated atmosphere. Perfect for couples seeking a natural, intimate celebration surrounded by lush gardens and farm-to-table cuisine.",
    description_es: "Un entorno único de granja orgánica que ofrece una atmósfera rústica pero sofisticada. Perfecto para parejas que buscan una celebración natural e íntima rodeada de exuberantes jardines y cocina de la granja a la mesa.",
    imageUrl: "https://images.squarespace-cdn.com/content/v1/59307e96f5e231d2d07636f7/b14c46d2-1ac3-420c-b272-06dc01a50b48/Flora_Farms_Cabo_Wedding_Photographers_Sara_Richardson-2034-scaled.jpg?format=2500w",
    rating: "4.8/5.0",
    location: "los-cabos",
    type: "Organic Farm",
    website: "https://www.flora-farms.com",
    features: {
      primary: ["Farm", "Garden", "Rustic"],
      amenities: ["Restaurant", "Garden", "Farm Tour", "Cooking Classes"],
      settings: ["Garden", "Farm", "Restaurant", "Outdoor"]
    },
    capacity: {
      min: 20,
      max: 100
    },
    pricing: {
      base: 12000,
      min: 8000,
      max: 15000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestUnique"]
  },
  "montage-los-cabos": {
    id: "montage-los-cabos",
    name: "Montage Los Cabos",
    name_es: "Montage Los Cabos",
    description: "An exclusive beachfront resort offering unparalleled luxury and privacy. With stunning ocean views, world-class amenities, and exceptional service, it's the perfect setting for an unforgettable celebration.",
    description_es: "Un exclusivo resort frente al mar que ofrece lujo y privacidad sin igual. Con impresionantes vistas al océano, comodidades de clase mundial y servicio excepcional, es el escenario perfecto para una celebración inolvidable.",
    imageUrl: "https://uploads.montage.com/uploads/sites/7/2024/09/13073632/Montage-Los-Cabos-Aerial-View-24024-1536x1150.jpg",
    rating: "5.0/5.0",
    location: "los-cabos",
    type: "Luxury Resort",
    website: "https://www.montagehotels.com/los-cabos",
    features: {
      primary: ["Beachfront", "Luxury", "Exclusive"],
      amenities: ["Spa", "Private Beach", "Fine Dining", "Butler Service"],
      settings: ["Beach", "Garden", "Ballroom", "Restaurant"]
    },
    capacity: {
      min: 30,
      max: 180
    },
    pricing: {
      base: 19000,
      min: 14000,
      max: 24000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "four-seasons-mexico-city": {
    id: "four-seasons-mexico-city",
    name: "Four Seasons Hotel Mexico City",
    name_es: "Hotel Four Seasons Ciudad de México",
    description: "A luxury hotel set in a historic building, offering stunning views of the city and exceptional service. The elegant ballrooms and rooftop spaces provide the perfect setting for sophisticated celebrations.",
    description_es: "Un hotel de lujo ubicado en un edificio histórico, que ofrece impresionantes vistas de la ciudad y servicio excepcional. Los elegantes salones y espacios en la azotea proporcionan el escenario perfecto para celebraciones sofisticadas.",
    imageUrl: "/images/four-seasons-cdmx.jpg",
    rating: "5.0/5.0",
    location: "mexico-city",
    type: "Luxury Hotel",
    website: "https://www.fourseasons.com/mexico-city",
    features: {
      primary: ["Luxury", "Historic", "City View"],
      amenities: ["Spa", "Fine Dining", "Butler Service", "Rooftop"],
      settings: ["Ballroom", "Rooftop", "Garden", "Restaurant"]
    },
    capacity: {
      min: 50,
      max: 200
    },
    pricing: {
      base: 18000,
      min: 12000,
      max: 25000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "st-regis-mexico-city": {
    id: "st-regis-mexico-city",
    name: "St. Regis Mexico City",
    name_es: "St. Regis Ciudad de México",
    description: "A sophisticated hotel known for its elegant design, exceptional service, and stunning city views. The grand ballrooms and rooftop venues offer versatile spaces for memorable celebrations.",
    description_es: "Un hotel sofisticado conocido por su diseño elegante, servicio excepcional e impresionantes vistas de la ciudad. Los grandiosos salones y lugares en la azotea ofrecen espacios versátiles para celebraciones memorables.",
    imageUrl: "/images/st-regis.jpg",
    rating: "5.0/5.0",
    location: "mexico-city",
    type: "Luxury Hotel",
    website: "https://www.stregis.com/mexico-city",
    features: {
      primary: ["Luxury", "Modern", "City View"],
      amenities: ["Spa", "Fine Dining", "Butler Service", "Rooftop"],
      settings: ["Ballroom", "Rooftop", "Restaurant", "Garden"]
    },
    capacity: {
      min: 50,
      max: 250
    },
    pricing: {
      base: 20000,
      min: 15000,
      max: 30000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestLuxury"]
  },
  "hotel-condesa-df": {
    id: "hotel-condesa-df",
    name: "Hotel Condesa DF",
    name_es: "Hotel Condesa DF",
    description: "A boutique hotel in the trendy Condesa neighborhood, featuring modern design and a vibrant atmosphere. The rooftop terrace and stylish interiors create a contemporary setting for intimate celebrations.",
    description_es: "Un hotel boutique en el barrio de moda Condesa, con diseño moderno y una atmósfera vibrante. La terraza en la azotea y los interiores elegantes crean un ambiente contemporáneo para celebraciones íntimas.",
    imageUrl: "/images/condesa-df.jpg",
    rating: "4.9/5.0",
    location: "mexico-city",
    type: "Boutique Hotel",
    website: "https://www.hotelcondesa.com",
    features: {
      primary: ["Boutique", "Modern", "Trendy"],
      amenities: ["Rooftop", "Restaurant", "Bar", "Spa"],
      settings: ["Rooftop", "Restaurant", "Garden", "Indoor"]
    },
    capacity: {
      min: 30,
      max: 100
    },
    pricing: {
      base: 12000,
      min: 8000,
      max: 16000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestBoutique"]
  },
  "casa-polanco": {
    id: "casa-polanco",
    name: "Casa Polanco",
    name_es: "Casa Polanco",
    description: "An exclusive boutique hotel in the upscale Polanco neighborhood, offering personalized service and sophisticated design. The elegant spaces and beautiful gardens provide a refined setting for intimate celebrations.",
    description_es: "Un exclusivo hotel boutique en el elegante barrio de Polanco, que ofrece servicio personalizado y diseño sofisticado. Los espacios elegantes y hermosos jardines proporcionan un ambiente refinado para celebraciones íntimas.",
    imageUrl: "/images/casa-polanco.jpg",
    rating: "4.9/5.0",
    location: "mexico-city",
    type: "Boutique Hotel",
    website: "https://www.casapolanco.com",
    features: {
      primary: ["Boutique", "Elegant", "Garden"],
      amenities: ["Garden", "Restaurant", "Bar", "Spa"],
      settings: ["Garden", "Restaurant", "Indoor", "Terrace"]
    },
    capacity: {
      min: 30,
      max: 80
    },
    pricing: {
      base: 15000,
      min: 10000,
      max: 20000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestBoutique"]
  },
  "hotel-brick": {
    id: "hotel-brick",
    name: "Hotel Brick",
    name_es: "Hotel Brick",
    description: "A modern boutique hotel in the heart of Mexico City, featuring contemporary design and a prime location. The stylish spaces and rooftop venue offer a chic setting for urban celebrations.",
    description_es: "Un hotel boutique moderno en el corazón de Ciudad de México, con diseño contemporáneo y ubicación privilegiada. Los espacios elegantes y el lugar en la azotea ofrecen un ambiente chic para celebraciones urbanas.",
    imageUrl: "/images/hotel-brick.jpg",
    rating: "4.7/5.0",
    location: "mexico-city",
    type: "Boutique Hotel",
    website: "https://www.hotelbrick.com",
    features: {
      primary: ["Modern", "Urban", "Boutique"],
      amenities: ["Rooftop", "Restaurant", "Bar", "Spa"],
      settings: ["Rooftop", "Restaurant", "Indoor", "Terrace"]
    },
    capacity: {
      min: 30,
      max: 100
    },
    pricing: {
      base: 10000,
      min: 7000,
      max: 15000,
      currency: "USD",
      includes: ["Venue", "Basic Setup", "Coordination"]
    },
    lists: ["top2025", "bestBoutique"]
  },
  "luna-escondida-sma": {
    id: "luna-escondida-sma",
    name: "Luna Escondida",
    name_es: "Luna Escondida",
    description: "A secluded estate just outside San Miguel, Luna Escondida offers lakeside gardens, a European-style ballroom, and breathtaking mountain views—perfect for both intimate gatherings and grand celebrations.",
    description_es: "Una finca privada a las afueras de San Miguel, Luna Escondida ofrece jardines junto al lago, un salón de estilo europeo y vistas impresionantes a las montañas; ideal tanto para eventos íntimos como para grandes celebraciones.",
    imageUrl: "/images/sanmiguel_lunaescondida.jpg",
    location: "San Miguel de Allende, Guanajuato",
    rating: "5.0/5.0",
    features: {
      primary: ["Estate", "Ballroom", "Lakeside"],
      amenities: [],
      settings: ["Garden", "Ballroom", "Mountain View"]
    },
    capacity: {
      min: 50,
      max: 600
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: [],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  
  "casa-adela": {
    "id": "casa-adela",
    "name": "Casa Adela",
    "name_es": "Casa Adela",
    "description": "A boutique hotel nestled atop a hill in Atotonilco, offering panoramic views of the San Miguel de Allende valley. Casa Adela combines contemporary Mexican architecture with natural charm, featuring outdoor pergolas, terraces, and spacious patios—ideal for intimate and enchanting weddings.",
    "description_es": "Un hotel boutique ubicado en lo alto de una colina en Atotonilco, que ofrece vistas panorámicas del valle de San Miguel de Allende. Casa Adela combina arquitectura mexicana contemporánea con encanto natural, con pérgolas al aire libre, terrazas y amplios patios, ideales para bodas íntimas y encantadoras.",
    "imageUrl": "/images/sanmiguel_casaadela.jpg",
    "location": "Atotonilco, San Miguel de Allende, Guanajuato",
    "rating": "5.0/5.0",
    "features": {
      "primary": ["Boutique Hotel", "Hilltop Views", "Outdoor Spaces"],
      "amenities": [],
      "settings": ["Garden", "Terrace", "Panoramic View"]
    },
    "capacity": {
      "min": 30,
      "max": 150
    },
    "pricing": {
      "base": null,
      "min": null,
      "max": null,
      "currency": "USD",
      "includes": [],
      "note": "Pricing unavailable; contact venue for details."
    }
  },
  "agua-bendita-sma": {
    id: "agua-bendita-sma",
    name: "Agua Bendita",
    name_es: "Agua Bendita",
    description: "A romantic venue surrounded by greenery and open spaces, Agua Bendita features lush gardens, a large esplanade, and stylish accommodations for a magical wedding experience.",
    description_es: "Un lugar romántico rodeado de áreas verdes y espacios abiertos; Agua Bendita ofrece jardines exuberantes, una gran explanada y alojamientos con estilo para una experiencia de boda mágica.",
    imageUrl: "/images/sanmiguel_aguabendita.jpg",
    location: "San Miguel de Allende, Guanajuato",
    rating: "4.9/5.0",
    features: {
      primary: ["Garden", "Esplanade", "Accommodations"],
      amenities: [],
      settings: ["Garden", "Outdoor", "Estate"]
    },
    capacity: {
      min: 50,
      max: 350
    },
    pricing: {
      base: null,
      min: null,
      max: null,
      currency: "USD",
      includes: [],
      note: "Pricing unavailable; contact venue for details."
    }
  },
  "casa-chorro": {
    "id": "casa-chorro",
    "name": "Casa Chorro",
    "name_es": "Casa Chorro",
    "description": "A stunning colonial estate perched above San Miguel de Allende, Casa Chorro offers panoramic city views, lush gardens, and elegant terraces. With its blend of historic charm and modern luxury, it's an ideal setting for intimate weddings and exclusive events.",
    "description_es": "Una impresionante finca colonial ubicada sobre San Miguel de Allende, Casa Chorro ofrece vistas panorámicas de la ciudad, jardines exuberantes y elegantes terrazas. Con su mezcla de encanto histórico y lujo moderno, es el lugar ideal para bodas íntimas y eventos exclusivos.",
    "imageUrl": "/images/sanmiguel_casa_chorro.jpg",
    "location": "San Miguel de Allende, Guanajuato",
    "rating": "5.0/5.0",
    "features": {
      "primary": ["Historic Estate", "Panoramic Views", "Lush Gardens"],
      "amenities": ["Swimming Pool", "Terraces", "Event Spaces"],
      "settings": ["Colonial", "Outdoor", "Luxury"]
    },
    "capacity": {
      "min": 50,
      "max": 150
    },
    "pricing": {
      "base": null,
      "min": null,
      "max": null,
      "currency": "USD",
      "includes": [],
      "note": "Pricing unavailable; contact venue for details."
    }},
    "hacienda-san-jose-lavista": {
    "id": "hacienda-san-jose-lavista",
    "name": "Hacienda San José Lavista",
    "name_es": "Hacienda San José Lavista",
    "description": "A spectacular vineyard estate just outside San Miguel, Hacienda San José Lavista features panoramic views of the vineyards, a contemporary chapel, elegant event spaces, and luxury accommodations. Perfect for refined, picturesque weddings and exclusive celebrations surrounded by nature and wine country charm.",
    "description_es": "Un espectacular viñedo a las afueras de San Miguel, Hacienda San José Lavista ofrece vistas panorámicas a los viñedos, una capilla contemporánea, elegantes espacios para eventos y alojamiento de lujo. Ideal para bodas refinadas y celebraciones exclusivas rodeadas de naturaleza y encanto vinícola.",
    "imageUrl": "/images/sanmiguel_haciendasanjoselavista.jpg",
    "location": "San Miguel de Allende, Guanajuato",
    "rating": "5.0/5.0",
    "features": {
      "primary": ["Vineyard", "Hacienda", "Luxury"],
      "amenities": ["Winery", "Chapel", "Luxury Suites", "Event Lawn"],
      "settings": ["Vineyard", "Countryside", "Panoramic Views"]
    },
    "capacity": {
      "min": 50,
      "max": 400
    },
    "pricing": {
      "base": null,
      "min": null,
      "max": null,
      "currency": "USD",
      "includes": [],
      "note": "Pricing unavailable; contact venue for details."
    }
  
  }
}; 